
import { useEffect, useState } from "react";
import { _QualityInspectionProductItem, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { SelectTHConstantsValue } from "../../../../../bpm/config/Componentes/SelectTHConstantsValue";
import usePaginator from "../../../../../theme/Component/usePaginator";

interface componentData {
    QualityInspectionProdcut: any
}

export const QualityInspectionProductItem = ({ QualityInspectionProdcut }: componentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityInspectionProductItem)
    const paginator = usePaginator();

    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar Inspección", MODAL_SM);

    const head = [
        { title: 'ID', property: 'IDQualityInspectionProductItem', visible: true },
        { title: 'Norma o Especificación Técnica', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: '¿Cumple con la Satisfacción?', property: 'SatisfyName', visible: true },
    ];

    useEffect(() => {
        if (QualityInspectionProdcut?.IDQualityInspectionProduct) {
            getLista();
        }
    }, [QualityInspectionProdcut?.IDQualityInspectionProduct, paginator.page])

    const getLista = () => {
        const props = {
            IDQualityInspectionProduct: QualityInspectionProdcut?.IDQualityInspectionProduct,
            State: 1
        }
        instance.getQualityInspectionProductItemRender(paginator.page, 15, props).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const create = () => {
        setBean({
            IDQualityInspectionProduct: QualityInspectionProdcut?.IDQualityInspectionProduct,
            State: 1,
            IDEmployee: _single.getAccountID(),
            PresentSpecialGarment: QualityInspectionProdcut?.IsEspecialGarment,
        });
        modal.open("Agregar Norma o Especificación");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Norma o Especificación") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionProductItem(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = [
            "Name", "Description", "Satisfy"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    pageTop={paginator.page}
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Norma o Especificación Técnica</label>
                            <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Satisfy') ? 'has-error' : ''}`} >Cumple con la Satisfacción</label>
                            <SelectTHConstantsValue label=" " code={907} onChange={(e) => { setBean({ ...bean, Satisfy: e }) }} value={bean.Satisfy} />
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`} >Descripción</label>
                            <textarea value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} className="form-control"></textarea>
                        </div>
                    </div>
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}